class MetadataStatus {
  DRAFT = "DRAFT";
  PENDING_VOICE_TALENT = "PENDING_VOICE_TALENT";
  READY_FOR_REVIEW = "READY_FOR_REVIEW";
  IN_PUBLISH_QUEUE = "IN_PUBLISH_QUEUE";
  PUBLISHED = "PUBLISHED";
  ARCHIVED = "ARCHIVED";
}

export default new MetadataStatus();
